<script setup lang="ts">
// PROPS
import { twMerge } from 'tailwind-merge';

const props = defineProps({
    class: { type: String, default: undefined },
});

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const mergedClass = twMerge('bg-neutral-50 p-4', props.class);
</script>

<template>
    <div class="flex flex-row items-center justify-between gap-x-14 rounded-xl" :class="mergedClass">
        <div>
            <p class="text-xs font-extrabold uppercase">{{ tt('customerServiceContact.title') }}</p>
            <p class="text-toned text-sm leading-5">{{ tt('customerServiceContact.description') }}</p>
        </div>
        <div class="flex flex-row items-center gap-x-4">
            <FleequidPhoneLink class="bg-primary-900 text-inverted rounded-full p-3 leading-[0]">
                <UIcon name="lucide:phone" class="size-6" />
            </FleequidPhoneLink>
            <FleequidEmailLink type="customerService" class="bg-primary-500 text-inverted rounded-full p-3 leading-[0]">
                <UIcon name="lucide:mail" class="size-6" />
            </FleequidEmailLink>
        </div>
    </div>
</template>
